export default "__VITE_ASSET__qrTO1V4R__"